interface ForwardButtonSVGProps {
  color: string;
  style: React.CSSProperties;
}

const ForwardButtonSVG = ({ color, style }: ForwardButtonSVGProps) => (
  <svg
    style={style}
    width="120"
    height="120"
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="60"
      cy="60"
      r="56.3636"
      stroke="#D9D9D9"
      strokeWidth="7.27273"
    />
    <path
      d="M84.0625 64.8125C84.0625 69.5716 82.6513 74.2239 80.0072 78.1809C77.3632 82.138 73.6052 85.2221 69.2083 87.0434C64.8115 88.8646 59.9733 89.3411 55.3057 88.4127C50.638 87.4842 46.3505 85.1925 42.9853 81.8273C39.6201 78.4621 37.3283 74.1745 36.3999 69.5069C35.4714 64.8392 35.9479 60.001 37.7692 55.6042C39.5904 51.2073 42.6745 47.4493 46.6316 44.8053C50.5887 42.1612 55.2409 40.75 60 40.75H69.625V52.7812L84.0625 38.3438L69.625 23.9062V35.9375H60C54.2891 35.9375 48.7064 37.631 43.9579 40.8038C39.2095 43.9766 35.5085 48.4863 33.323 53.7625C31.1375 59.0387 30.5657 64.8445 31.6798 70.4457C32.794 76.0469 35.5441 81.192 39.5823 85.2302C43.6205 89.2684 48.7656 92.0185 54.3668 93.1327C59.968 94.2468 65.7738 93.675 71.05 91.4895C76.3262 89.304 80.8359 85.6031 84.0087 80.8546C87.1815 76.1061 88.875 70.5234 88.875 64.8125H84.0625Z"
      fill={color}
    />
    <path
      d="M68.7336 74.7495C67.6704 74.7756 66.6158 74.5531 65.6536 74.0998C64.7993 73.6662 64.0641 73.0301 63.5121 72.247C62.907 71.3334 62.4822 70.3124 62.2608 69.2392C61.9765 67.9108 61.8393 66.5551 61.8518 65.1967C61.842 63.8384 61.9791 62.483 62.2608 61.1542C62.4867 60.0823 62.9111 59.0622 63.5121 58.1464C64.0641 57.3633 64.7993 56.7272 65.6536 56.2936C66.6158 55.8403 67.6704 55.6178 68.7336 55.6439C69.7333 55.5678 70.7359 55.749 71.6457 56.1702C72.5555 56.5915 73.3423 57.2386 73.9311 58.0501C75.1719 60.1842 75.7577 62.636 75.6155 65.1004C75.7577 67.5649 75.1719 70.0167 73.9311 72.1507C73.3647 72.9976 72.5877 73.6826 71.6764 74.1382C70.7652 74.5939 69.751 74.8045 68.7336 74.7495ZM68.7336 71.8139C69.2187 71.8428 69.7021 71.7339 70.1279 71.4998C70.5537 71.2656 70.9046 70.9156 71.1399 70.4904C71.7149 69.3649 72.0198 68.1209 72.0302 66.857V63.5364C72.0822 62.2953 71.8433 61.0592 71.3324 59.927C71.0634 59.5149 70.6959 59.1764 70.2632 58.9421C69.8304 58.7078 69.3461 58.5851 68.8539 58.5851C68.3618 58.5851 67.8775 58.7078 67.4447 58.9421C67.012 59.1764 66.6445 59.5149 66.3755 59.927C65.8646 61.0592 65.6257 62.2953 65.6777 63.5364V66.857C65.6281 68.1057 65.8669 69.349 66.3755 70.4904C66.605 70.9099 66.9478 71.2564 67.3648 71.4904C67.7817 71.7244 68.256 71.8365 68.7336 71.8139ZM47.0774 74.4367V71.5973H51.8899V59.1089L47.4143 61.5151L46.0908 58.9645L51.6733 55.8364H55.1864V71.477H59.4696V74.4367H47.0774Z"
      fill={color}
    />
  </svg>
);

export default ForwardButtonSVG;
